import gql from "graphql-tag"
import { useQuery } from "react-apollo"
import { StatesQuery, StatesQueryVariables } from "typings/types"

const STATES_QUERY = gql`
  query States {
    states {
      label
      value
    }

    allowedStates {
      value
    }

    pillpackAllowedStates {
      label
      value
    }
  }
`

export const useStates = () => useQuery<StatesQuery, StatesQueryVariables>(STATES_QUERY)
